export const EMPTY_CHANNEL_VALUE = '--';